export const ADD_MATERIAL = '@@materials/add-material';
export const ADD_MATERIAL_SUCCESS = '@@materials/add-material-success';
export const ADD_MATERIAL_FAILURE = '@@materials/add-material-failure';

export const FETCH_MATERIALS = '@@materials/fetch-materials';
export const FETCH_MATERIALS_SUCCESS = '@@materials/fetch-materials-success';
export const FETCH_MATERIALS_FAILURE = '@@materials/fetch-materials-failure';

export const UPDATE_MATERIAL = '@@materials/update-material';
export const UPDATE_MATERIAL_SUCCESS = '@@materials/update-material-success';
export const UPDATE_MATERIAL_FAILURE = '@@materials/update-material-failure';

export const BULK_UPLOAD_MATERIALS = '@@materials/bulk-upload-materials';
export const BULK_UPLOAD_MATERIALS_SUCCESS = '@@materials/bulk-upload-materials-success';
export const BULK_UPLOAD_MATERIALS_FAILURE = '@@materials/bulk-upload-materials-failure';

export const SHARE_MATERIAL = '@@materials/share-material';
export const SHARE_MATERIAL_SUCCESS = '@@materials/share-material-success';
export const SHARE_MATERIAL_FAILURE = '@@materials/share-material-failure';

